import { BlogNewsListCardData } from '../blog-news/blog-news';
import { Seo } from '../seo-settings/seo-settings-types';
import { ImageWordpress } from '../../types/shared';

export type PageListCardSource = {
    post_title?: string;
    permalink?: string;
    url?: string;
    seo?: Seo;
    isHealthcareProfessional?: boolean;
    isVisibleForPublic?: boolean;
};

/* og:image is a bare string on older content, an object on newer. */
const mapOgImageToCardImage = (ogImage: Seo['og_image']): ImageWordpress | undefined => {
    if (!ogImage) {
        return undefined;
    }

    if (typeof ogImage === 'string') {
        return { url: ogImage } as ImageWordpress;
    }

    return {
        url: ogImage.url,
        altText: ogImage.alt,
    } as ImageWordpress;
};

export const mapPageToListCardData = (page: PageListCardSource): BlogNewsListCardData => {
    return {
        url: page.url || page.permalink || '',
        permalink: page.permalink || '',
        listCardContent: {
            title: page.post_title,
            image: mapOgImageToCardImage(page.seo?.og_image),
        },
        isHealthcareProfessional: page.isHealthcareProfessional,
        isVisibleForPublic: page.isVisibleForPublic,
    };
};
